import { lazy, Suspense } from 'react';
import type { ComponentProps } from 'react';

// `react-player/file` is a deep CJS subpath whose module sets
// `exports.default = void 0` and only late-reassigns it further down the file.
// Under the Rolldown production build a static
// `import FilePlayer from 'react-player/file'` can capture that initial
// `void 0`, so the POTM video tiles silently render nothing in prod while the
// dev server looks fine (the §4b.6 Rolldown CJS `void 0` regression from the
// React Router v7 / Vite 8 migration — the web vite config gates `cjsInterop`
// to dev only, so it does not cover this in prod). Importing it lazily reads
// `.default` after the module has finished initialising, which sidesteps the
// capture and code-splits react-player out of the main bundle as a bonus.
//
// The POTM tiles only ever render the player post-hydration, so the Suspense
// boundary never runs during SSR.
const FilePlayerLazy = lazy(() => import('react-player/file'));

type FilePlayerProps = ComponentProps<typeof FilePlayerLazy>;

export const FilePlayer = (props: FilePlayerProps) => (
    <Suspense fallback={null}>
        <FilePlayerLazy {...props} />
    </Suspense>
);
